import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios"
import _Vue from "vue"
import { notifyRequestTimeout, notifyError } from "@/utils/notify"

const DEFAULT_CONFIG: AxiosRequestConfig = {
    baseURL: process.env.VUE_APP_BASE_URL,
    responseType: "json",
    headers: {
        "Content-Type": "application/json",
    },
    timeout: 180000,
    withCredentials: false,
}

export const api = (options: AxiosRequestConfig): Promise<AxiosResponse> => {
    return new Promise<AxiosResponse>((resolve, reject) => {
        const instance = axios.create(DEFAULT_CONFIG)

        instance.interceptors.request.use(
            (cfg: AxiosRequestConfig) => {
                return cfg
            },
            (err: AxiosError) => {
                return Promise.reject(err)
            }
        )

        instance.interceptors.response.use(
            (resp: AxiosResponse) => {
                return resp
            },
            (err: AxiosError) => {
                return Promise.reject(err)
            }
        )

        instance(options)
            .then((res: AxiosResponse) => resolve(res))
            .catch((err: AxiosError) => {
                if (err.code === "ECONNABORTED") {
                    notifyRequestTimeout()
                }

                if (
                    err.response &&
                    (err.response.status === 403 || err.response.status === 401)
                ) {
                    notifyError(
                        "Operation forbidden",
                        "Please make sure you have rights to do so"
                    )
                }

                reject(err)
            })
    })
}

export default {
    install: (Vue: typeof _Vue): void => {
        Vue.prototype.$api = api
    },
}

declare module "vue/types/vue" {
    interface Vue {
        $api: (options: AxiosRequestConfig) => Promise<AxiosResponse>
    }
}
